<template>
  <div>
    <v-card class="pa-3 rounded_max" elevation="1">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="pa-3">
            <p class="default_txt">Question</p>

            <v-textarea
              dense
              placeholder="Type Here"
              v-model="question.content"
              :error-messages="err"
              hide-details="auto"
              rows="2"
              auto-grow
              :color="color"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="pa-3">
            <p class="default_txt">Attempt</p>
            <v-text-field
              placeholder="Type Here"
              hide-details
              type="number"
              v-model="question.attempt"
              :color="color"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <div class="d-flex justify-end mt-4">
      <v-btn
        v-if="!loading"
        :class="` text-capitalize rounded-lg`"
        depressed
        dark
        :color="color"
        @click="validateCreate"
        >Create</v-btn
      >
      <v-btn
        v-if="loading"
        :class="` text-capitalize rounded-lg`"
        depressed
        dark
        :color="color"
        >Loading...</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "formAssigmnet",
  data() {
    return {
      loading: false,
      listType: ["multiple", "essay"],
      getAway: false,
      err: "",
      question: {
        content: "",
        attempt: 0,
      },
    };
  },
  props: ["color", "module"],
  methods: {
    validateCreate() {
      if (this.question.content != "") {
        this.createQuestion();
      } else {
        this.err = "Question cannot be empty!";
      }
    },
    createQuestion() {
      this.loading = true;
      this.err = "";
      let body = {
        course_assignment_id: this.module.id,
        content: this.question.content,
        attempt: this.question.attempt,
      };
      let data = {
        path: `manage/assignment/create`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((res) => {
          this.loading = false;
          this.question = "";
          this.$emit("refetch");
          this.$store.dispatch("notify", {
            msg: res.message,
            type: "success",
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
